<template>
  <div
    v-if="!loading"
    id="app">
    <transition 
      name="fade" 
      mode="out-in">
      <Modal v-if="modal"/>
    </transition>
    <template v-if="user">
      <template v-if="user.role === 'admin'">
        <template v-if="showAdminSideBar">
          <AdminSidebar/>
        </template>
        <template v-else-if="!showAdminSideBar">
          <Sidebar/>
        </template>
      </template>
      <template v-else-if="user.role !== 'admin'">
        <Sidebar/>
      </template>
    </template>
    <template v-if="user">
      <div class="content">
        <Navbar/>
        <transition
          name="fade"
          mode="out-in">
          <router-view/>
        </transition>
      </div>
    </template>
    <template v-else>
      <div class="content-login">
        <transition
          name="fade"
          mode="out-in">
          <router-view/>
        </transition>
      </div>
    </template>
  </div>
  <div
    v-else
    class="app">
    <div class="save-data-animation" >
      <img
        :src="getImageUrl('/images/animations/saving.svg')"
        alt="" >
    </div>
  </div>
</template>

<script>
import Modal from "./components/Modal";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import profileMixin from "@/mixins/profileMixin";
import {mapActions, mapGetters} from "vuex";
import AdminSidebar from "./components/AdminSidebar";

export default {
    name: 'App',
    components: {
        AdminSidebar,
        Modal,
        Navbar,
        Sidebar
    },
    mixins: [profileMixin],
    data() {
      return {
        loading: true
      }
    },
    computed: {
      ...mapGetters(['user', 'check', 'modal', 'quiz', 'token']),

      showAdminSideBar() {
        return  this.$route.matched.filter((val) => {
          return val.meta.isAdmin
        }).length > 0
      }
    },
    beforeMount: async function() {
      if (this.token) {
        await this.fetchUserData()
      } else {
        this.loading = false;
      }
    },
    methods: {
    ...mapActions(['fetchUser']),

    fetchUserData: async function() {
      await this.fetchUser().then(() => {
        this.loading = false;
      })
    },
  }
}
</script>
<style src="../src/assets/scss/app.scss" lang="scss"></style>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.app .save-data-animation {
  position: absolute;
  background: rgba(255,255,255,.9);
  color: #4b0565;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.app .save-data-animation  img {
  width: 80px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue